module.exports = __webpack_public_path__ + "static/img/l-3.c3520a27.png";